export const ClASSIFY_LIST = [
  { value: 0, name: '重要KPI', field: 'importantKPI', width: 100, weight: '' },
  { value: 10, name: '业务工作', field: 'business', width: 100, weight: '' },
  { value: 20, name: '费效管理', field: 'budgetAndCostControl', width: 150, weight: '' },
  { value: 30, name: '人力资源', field: 'humanResource', width: 100, weight: '' },
  { value: 40, name: '企业文化', field: 'corporateCultures', width: 100, weight: '' },
  { value: 95, name: '上半年权重', field: 'halfWeight', width: 100, weight: '' },
];